"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVotingTokenAmount = exports.deserializeStakeAccountPositions = exports.getAmountByTargetAndState = exports.getPositionState = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const web3_js_1 = require("@solana/web3.js");
const bn_1 = require("./bn");
const constants_1 = require("../constants");
const types_1 = require("../types");
const getPositionState = (position, currentEpoch) => {
    if (currentEpoch < position.activationEpoch) {
        return types_1.PositionState.LOCKING;
    }
    if (!position.unlockingStart) {
        return types_1.PositionState.LOCKED;
    }
    const hasActivated = position.activationEpoch <= currentEpoch;
    const unlockStarted = position.unlockingStart <= currentEpoch;
    const unlockEnded = position.unlockingStart + 1n <= currentEpoch;
    if (hasActivated && !unlockStarted) {
        return types_1.PositionState.PREUNLOCKING;
    }
    else if (unlockStarted && !unlockEnded) {
        return types_1.PositionState.UNLOCKING;
    }
    else {
        return types_1.PositionState.UNLOCKED;
    }
};
exports.getPositionState = getPositionState;
const getAmountByTargetAndState = (options) => {
    const { stakeAccountPositions, targetWithParameters, positionState, epoch } = options;
    return stakeAccountPositions.data.positions
        .filter((p) => (0, exports.getPositionState)(p, epoch) === positionState)
        .filter((p) => {
        if (targetWithParameters.voting) {
            return p.targetWithParameters.voting !== undefined;
        }
        return (p.targetWithParameters.integrityPool?.publisher &&
            targetWithParameters.integrityPool.publisher.equals(p.targetWithParameters.integrityPool.publisher));
    })
        .map((p) => p.amount)
        .reduce((sum, amount) => sum + amount, 0n);
};
exports.getAmountByTargetAndState = getAmountByTargetAndState;
const deserializeStakeAccountPositions = (address, data, idl) => {
    const coder = new anchor_1.BorshCoder(idl);
    let i = 8; // Skip discriminator
    const owner = new web3_js_1.PublicKey(data.slice(i, i + 32));
    const numberOfPositions = Math.floor((data.length - constants_1.POSITIONS_ACCOUNT_HEADER_SIZE) / constants_1.POSITION_BUFFER_SIZE);
    i += 32;
    const positions = [];
    for (let j = 0; j < numberOfPositions; j++) {
        if (data[i] === 1) {
            positions.push(coder.types.decode("position", data.subarray(i + 1)));
        }
        i += constants_1.POSITION_BUFFER_SIZE;
    }
    return {
        address,
        data: {
            owner,
            positions: positions.map((p) => (0, bn_1.convertBNToBigInt)(p)),
        },
    };
};
exports.deserializeStakeAccountPositions = deserializeStakeAccountPositions;
const getVotingTokenAmount = (stakeAccountPositions, epoch) => {
    const positions = stakeAccountPositions.data.positions;
    const votingPositions = positions
        .filter((p) => p.targetWithParameters.voting)
        .filter((p) => [types_1.PositionState.LOCKED, types_1.PositionState.PREUNLOCKING].includes((0, exports.getPositionState)(p, epoch)));
    const totalVotingTokenAmount = votingPositions.reduce((sum, p) => sum + p.amount, 0n);
    return totalVotingTokenAmount;
};
exports.getVotingTokenAmount = getVotingTokenAmount;
